export const config2 = {
	automaticRearrangeAfterDropNode: false,
	collapsible: false,
	directed: false,
	focusAnimationDuration: 0.75,
	focusZoom: 1,
	freezeAllDragEvents: false,
	height: 400,
	highlightDegree: 1,
	highlightOpacity: 1,
	linkHighlightBehavior: false,
	maxZoom: 8,
	minZoom: 0.1,
	nodeHighlightBehavior: false,
	panAndZoom: false,
	staticGraph: false,
	staticGraphWithDragAndDrop: false,
	width: 800,
	d3: {
		alphaTarget: 0.05,
		gravity: -100,
		linkLength: 100,
		linkStrength: 1,
		disableLinkForce: false,
	},
	node: {
		color: '#d3d3d3',
		fontColor: 'black',
		fontSize: 8,
		fontWeight: 'normal',
		highlightColor: 'SAME',
		highlightFontSize: 8,
		highlightFontWeight: 'normal',
		highlightStrokeColor: 'SAME',
		highlightStrokeWidth: 'SAME',
		labelProperty: 'id',
		mouseCursor: 'pointer',
		opacity: 1,
		renderLabel: true,
		size: 200,
		strokeColor: 'none',
		strokeWidth: 1.5,
		svg: '',
		symbolType: 'circle',
	},
	link: {
		color: '#d3d3d3',
		fontColor: 'black',
		fontSize: 8,
		fontWeight: 'normal',
		highlightColor: 'SAME',
		highlightFontSize: 8,
		highlightFontWeight: 'normal',
		labelProperty: 'label',
		mouseCursor: 'pointer',
		opacity: 1,
		renderLabel: false,
		semanticStrokeWidth: false,
		strokeWidth: 1.5,
		markerHeight: 6,
		markerWidth: 6,
		strokeDasharray: 0,
		strokeDashoffset: 0,
		strokeLinecap: 'butt',
	},
};

// 色票：適用於以 target, source, foucs 來區分顏色
export const nodeColorsSrcDst = {
	src: '#db2828',
	// src: '#E56997',
	// dst: '#fbbd08',
	dst: '#FBC740',
	focus: '#2185d0',
};

// 色票：適用於以 (node prop) region 來區分 node 的顏色
export const nodeColorsRegion = {
	default: '#b8b8d1',
	southasian: '#5b5f97',
	centralasian: '#0267c1',
	westasian: '#ffc145',
	eastasian: '#efaac4',
	european: '#fcf300',
	africa: '#ff6700',
};

// 色票: for link
export const linkColors = {
	default: 'rgb(211, 211, 211)',
	focus: '#2185d0',
};

export const getConfig = ({ snaWidth, defaultSnaWidth, snaHeight, renderLabel, nodeFontSize, linkFontSize }) => ({
	nodeHighlightBehavior: false, // 是否觸發 node highlight
	linkHighlightBehavior: false, // 是否觸發 link highlight
	directed: false, // link 是否有方向性
	maxZoom: 8,
	panAndZoom: true,
	width: snaWidth || defaultSnaWidth,
	height: snaHeight,

	node: {
		color: '#d3d3d3',
		size: 280,
		highlightStrokeColor: nodeColorsSrcDst.focus,
		fontSize: nodeFontSize,
		labelProperty: 'label',
	},
	link: {
		color: linkColors.default,
		// highlightColor: '#2185d0',
		highlightColor: linkColors.focus,
		renderLabel: false,
		labelProperty: 'label',
		fontSize: linkFontSize,
		type: 'CURVE_SMOOTH',
	},
	d3: {
		alphaTarget: 0.05,
		gravity: -200,
		linkLength: 100,
		linkStrength: 1,
	},
});

// config for label text
export const labelTextConfig = {
	default: {
		headerSize: 'h4',
	},
	publicationen: {
		headerSize: 'h4',
		iconName: 'book',
		labelText: 'Publication',
		order: 1,
		color: 'blue',
		public: true,
	},
	publicationfa: {
		headerSize: 'h5',
		iconName: 'book',
		labelText: 'Publication(fa)',
		order: 2,
		color: 'blue',
		dir: 'rtl',
		public: true,
	},
	// 引用
	cited: {
		headerSize: 'h5',
		iconName: 'book',
		labelText: 'Cited by',
		order: 1,
		color: 'blue',
		public: true,
	},
	// 被引用
	citing: {
		headerSize: 'h5',
		iconName: 'book',
		labelText: 'Citations',
		order: 1,
		color: 'blue',
		public: true,
	},
	authoren: {
		headerSize: 'h4',
		iconName: 'user outline',
		labelText: 'Author',
		order: 3,
		color: 'teal',
		public: true,
	},
	authorfa: {
		headerSize: 'h5',
		iconName: 'user outline',
		labelText: 'Author(fa)',
		order: 4,
		color: 'teal',
		dir: 'rtl',
		public: true,
	},
	location: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'Location',
		order: 7,
		color: 'orange',
		public: true,
	},
	country: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'country',
		order: 8,
		color: 'orange',
		public: true,
	},
	region: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'region',
		order: 9,
		color: 'orange',
		public: false,
	},
	completiondate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'Completion date',
		order: 11,
		color: 'grey',
		public: true,
	},
	birthdate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'Birthdate',
		order: 12,
		color: 'grey',
		public: false,
	},
	deathdate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'Deathdate',
		order: 12,
		color: 'grey',
		public: false,
	},
	placeofbirthen: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'Place of birth',
		order: 13,
		color: 'orange',
		public: false,
	},
	placeofdeathen: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'Place of death',
		order: 13,
		color: 'orange',
		public: false,
	},
	startdate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'Start date',
		order: 14,
		color: 'grey',
		public: false,
	},
	enddate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'End date',
		order: 15,
		color: 'grey',
		public: false,
	},
	metadata: {
		headerSize: 'h5',
		iconName: 'info',
		labelText: 'Metadata',
		order: 20,
		color: 'grey',
		public: true,
	},
};

export const webInfoText = `
This network map displays the tadhkiras cited, utilized, and/or relied upon by ***Bahāristān-i sukhan*** (1746-7), ***Majmaʿ al-nafāʾis*** (1750-1), ***Sarv-i Āzād*** (1752-3), ***Tadhkira-yi bī-naẓīr*** (1758-9), ***Khizānah-yi ʿāmirah*** (1762-3), ***Gul-i raʿnā*** (1768-9), ***Ātishkadah*** (1779), ***Ṣuḥuf-i Ibrāhīm*** (1790-1), ***Nishtar-i ʿishq*** (1818), ***Natāʾij al-afkār*** (1842), ***Majmaʿ al-fuṣaḥāʾ*** (1871), ***Nigāristān-i sukhan*** (1875) according to information recounted in Gulchīn-i Maʿānī’s *Tārīkh-i tadhkira-hā-yi Fārsī* and Naqavī’s *Tadhkira-navīsī dar Hind va Pākistān*  as well as detailed in the works themselves. Click one of these twelve nodes (appearing in yellow) to see the other *tadhkiras* connected to them or click on any other node in red to see their position in the network.
`;
